import { useCallback } from 'react'

export const useLabelWidth = (formFieldType: string) => {

    const getTextWidth = useCallback((text: string, fontFamily: string, fontSize = formFieldType === 'floating-label-compact' ? '11px' : '10px') => {
        const canvas = document.createElement("canvas")
        const context: any = canvas.getContext("2d")
        
        if (context) {
            context.font = `${fontSize} ${fontFamily}`
            const metrics = context.measureText(text)
            return metrics.width 
        }
    },[formFieldType])

    return getTextWidth
}
